import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const BENCHMARK_TERMINAL_STATE: Set<CubiqTS.OrderState> = new Set([
  CubiqTS.OrderState.REJECTED,
  CubiqTS.OrderState.CANCELLED,
  CubiqTS.OrderState.CLIENT_REJECTED,
  CubiqTS.OrderState.TRADER_REJECTED,
  CubiqTS.OrderState.DELETED,
  CubiqTS.OrderState.SALES_REJECTED,
  CubiqTS.OrderState.FILLED,
  CubiqTS.OrderState.EXPIRED,
]);
